(function() { window.GUID_d60a12c6_0874_441a_95e8_38b91fbe91d3 = { getGuid: function() { return "d60a12c6-0874-441a-95e8-38b91fbe91d3"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let SVGIcon;
        (function (SVGIcon) {
            SVGIcon[SVGIcon["Clock"] = 0] = "Clock";
            SVGIcon[SVGIcon["GridLayout"] = 1] = "GridLayout";
            SVGIcon[SVGIcon["CardLayout"] = 2] = "CardLayout";
            SVGIcon[SVGIcon["QuickTournamentIllustration"] = 3] = "QuickTournamentIllustration";
            SVGIcon[SVGIcon["Charts"] = 4] = "Charts";
            SVGIcon[SVGIcon["Videos"] = 5] = "Videos";
            SVGIcon[SVGIcon["Favorites"] = 6] = "Favorites";
            SVGIcon[SVGIcon["Notifications"] = 7] = "Notifications";
            SVGIcon[SVGIcon["Info"] = 8] = "Info";
            SVGIcon[SVGIcon["InfoYellow"] = 9] = "InfoYellow";
        })(SVGIcon = Enumeration.SVGIcon || (Enumeration.SVGIcon = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=SVGIcon.pre.js.map
